import { __awaiter, __generator } from "tslib";
import { w } from '@tinkoff/statist-page-data';
import { validateSharedParameters, validateVersion } from './utils';
var IosBridge = /** @class */ (function () {
    function IosBridge() {
        var _this = this;
        var _a, _b;
        this.version = null;
        this.apiKey = null;
        this.sharedParameters = null;
        this.receivedActions = new Set();
        this.initialized = false;
        this.resolveInitialized = function () { };
        this.initializedPromise = new Promise(function (resolve) {
            _this.resolveInitialized = resolve;
        });
        this.handleNativeMessage = function (action, value) {
            if (!_this.initialized) {
                _this.receivedActions.add(action);
                if (_this.receivedActions.has('getVersion') &&
                    _this.receivedActions.has('getSharedParameters') &&
                    _this.receivedActions.has('getApiKey')) {
                    _this.initialized = true;
                    _this.resolveInitialized(true);
                }
            }
            if (action === 'getVersion') {
                _this.version = typeof value === 'string' ? value : null;
            }
            else if (action === 'getSharedParameters' && validateSharedParameters(value)) {
                _this.sharedParameters = value;
            }
            else if (action === 'getApiKey' && (typeof value === 'string' || value === null)) {
                _this.apiKey = value;
            }
        };
        if (typeof ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.statistNativeSdk) !== 'undefined') {
            w._statistIosSdkRecipient = this.handleNativeMessage;
            this.refreshVersion();
            this.refreshApiKeyParameters();
            this.refreshSharedParameters();
            setInterval(function () {
                _this.refreshSharedParameters();
            }, 10000);
        }
    }
    IosBridge.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initializedPromise];
                    case 1:
                        _a.sent();
                        if (!validateVersion(this.version)) {
                            throw new Error('Unsupported version of bridge');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    IosBridge.prototype.isConnected = function () {
        var _a, _b;
        return !!((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.statistNativeSdk);
    };
    IosBridge.prototype.getSharedParameters = function () {
        return this.sharedParameters;
    };
    IosBridge.prototype.getApiKey = function () {
        return this.apiKey;
    };
    IosBridge.prototype.notifyEventHappened = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = w.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.statistNativeSdk) === null || _c === void 0 ? void 0 : _c.postMessage('notifyEventHappened');
    };
    IosBridge.prototype.refreshVersion = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = w.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.statistNativeSdk) === null || _c === void 0 ? void 0 : _c.postMessage('getVersion');
    };
    IosBridge.prototype.refreshApiKeyParameters = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = w.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.statistNativeSdk) === null || _c === void 0 ? void 0 : _c.postMessage('getApiKey');
    };
    IosBridge.prototype.refreshSharedParameters = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = w.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.statistNativeSdk) === null || _c === void 0 ? void 0 : _c.postMessage('getSharedParameters');
    };
    return IosBridge;
}());
export { IosBridge };
//# sourceMappingURL=ios-bridge.js.map